import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ShieldCheck, Award, TrendingUp, Eye, MessageSquare, Handshake, LineChart, Heart } from 'lucide-react';
import SectionHead from '@/components/SectionHead';
import { PARENT_PROMISE } from '@/data/content';
import { fadeUp, stagger, viewportOnce, scrollToHash } from '@/lib/motion';

const ICONS = { ShieldCheck, Award, TrendingUp, Eye, MessageSquare, Handshake, LineChart, Heart };

export default function ParentPromise() {
  return (
    <section id="parents" className="relative py-24 sm:py-32 bg-night-surface border-y border-white/5" data-testid="parent-promise-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="10"
          eyebrow="Parent Promise"
          title={'WHAT PARENTS\nCAN EXPECT.'}
          testId="parent-promise-heading"
        />
        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6"
        >
          {PARENT_PROMISE.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <motion.div
                key={p.title} variants={fadeUp} custom={i}
                whileHover={{ y: -5 }}
                className="glass-card rounded-sm p-6 sm:p-7 hover:border-brand-gold/40 transition-[border-color,transform] duration-300"
                data-testid={`promise-${p.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
              >
                <Icon size={24} strokeWidth={1.5} className="text-brand-gold" />
                <h3 className="mt-4 font-display text-lg sm:text-xl tracking-wide text-white uppercase leading-tight">{p.title}</h3>
              </motion.div>
            );
          })}
        </motion.div>
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="mt-12">
          <button onClick={() => scrollToHash('#coaches')} data-testid="meet-asa-cta"
            className="bg-brand-red hover:bg-brand-redhover text-white font-display tracking-widest text-xl px-10 py-4 rounded-sm transition-colors duration-300">
            MEET ASA
          </button>
        </motion.div>
      </div>
    </section>
  );
}
